"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectClient = void 0;
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const _ = require("lodash");
const client_1 = require("./client");
const baseURL = "/connect-management/client";
class ConnectClient extends client_1.Client {
    constructor(params) {
        super();
        Object.assign(this, params);
        this.formatTimestamps();
    }
    formatTimestamps() {
        this.createdAtFormatted = this.createdAt
            ? moment(this.createdAt).format("MM/DD/YY h:mm A")
            : this.createdAt;
        this.updatedAtFormatted = this.updatedAt
            ? moment(this.updatedAt).format("MM/DD/YY h:mm A")
            : this.updatedAt;
    }
    setName(name) {
        this.name = name;
    }
    create() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.post(`${baseURL}`, this.params()).toPromise();
                let json = yield response.json();
                let client = new ConnectClient(json);
                return client;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http
                    .put(`${baseURL}/${this.id}`, this.params())
                    .toPromise();
                let json = yield response.json();
                let client = new ConnectClient(json);
                Object.assign(this, client);
                return this;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    destroy() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
                let response = yield http.delete(`${baseURL}/${this.id}`).toPromise();
                let json = yield response.json();
                let client = new ConnectClient(json[0]);
                Object.assign(this, client);
                return this;
            }
            catch (err) {
                let json = yield err.json();
                throw json;
            }
        });
    }
    sync() {
        return __awaiter(this, void 0, void 0, function* () {
            this.synchronize = true;
            let client = yield this.update();
            this.synchronize = false;
            return client;
        });
    }
    params() {
        let params = _.pick(this, [
            "organization",
            "rtbxId",
            "name",
            "synchronize",
        ]);
        return _(params)
            .omit(_.isUndefined)
            .omit(_.isNull)
            .value();
    }
}
exports.ConnectClient = ConnectClient;
//# sourceMappingURL=connect-client.js.map